import { clsx } from 'clsx';
import type { StockStatuses } from '../types';

const getClassNamesFromStockStatuses = ({
    statuses,
    status,
    lineIndicator,
    isMixed,
    styles,
    square,
}: {
    lineIndicator?: boolean;
    statuses?: StockStatuses[];
    status?: StockStatuses;
    isMixed?: boolean;
    square?: boolean;
    styles: {
        readonly [key: string]: string;
    };
}) => {
    return clsx(
        styles.stockIndicator,
        ...(statuses ? statuses.map(statusItem => styles[statusItem]) : []),
        status && styles[status],
        {
            [styles.square]: square,
            [styles.lineIndicator]: lineIndicator,
            [styles.mixed]: isMixed,
        }
    );
};

export default getClassNamesFromStockStatuses;
